import React, { useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";
import { DashboardEditorProps } from "components/ComponentType";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import CommonChartEditor from "../../CommonChartEditor";
import { DatasetChartProps } from "../../interfaces";

function HistogramChartEditor({ config, onConfigChange }: DashboardEditorProps<DatasetChartProps>) {
  const [referenceTime, setReferenceTime] = useState(() => {
    if (config.referenceTime === undefined) {
      return new Date();
    }
    return new Date(config.referenceTime);
  });
  const onReferenceTimeChange = (e: Date | undefined) => {
    if (!e) return;
    const isoString = e.toISOString();
    setReferenceTime(e);
    onConfigChange({ ...config, referenceTime: isoString });
  };
  return (
    <div>
      <div className="flex flex-wrap justify-content-between mb-3">
        <div className="flex flex-column gap-2 mb-3">
          <label htmlFor="referenceTime">{T("load-conf.reference-time")}</label>
          <CalendarWrapper
            id="referenceTime"
            value={referenceTime}
            onChange={onReferenceTimeChange}
            className="p-mr-2"
            debounceTimeInMs={300}
          />
        </div>
        <div className="flex flex-column gap-2 w-10rem">
          <label htmlFor="binsSize">Bins Size</label>
          <InputNumber
            id="binsSize"
            value={config.bins?.size}
            onValueChange={e => {
              onConfigChange({
                ...config,
                bins: { ...config.bins, size: e.value ?? undefined },
              });
            }}
            className="p-mr-2"
          />
        </div>
        <div className="flex flex-column gap-2 w-10rem">
          <label htmlFor="binsStart">Bins Start</label>
          <InputNumber
            id="binsStart"
            value={config.bins?.start}
            onValueChange={e => {
              onConfigChange({
                ...config,
                bins: { ...config.bins, start: e.value ?? undefined },
              });
            }}
            className="p-mr-2"
          />
        </div>
        <div className="flex flex-column gap-2 w-10rem">
          <label htmlFor="binsEnd">Bins End</label>
          <InputNumber
            id="binsEnd"
            value={config.bins?.end}
            onValueChange={e => {
              onConfigChange({
                ...config,
                bins: { ...config.bins, end: e.value ?? undefined },
              });
            }}
            className="p-mr-2"
          />
        </div>
      </div>

      <CommonChartEditor config={config} onConfigChange={onConfigChange} />
    </div>
  );
}
export default HistogramChartEditor;
